import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import DownloadItem from './DownloadItem'
import Filter from './Filter'
import useDownloads from './useDownloads'
import { _project } from 'state/store.projects'
import { getProjectData } from 'state/jotai.projectDataHooks'

function Downloads() {
  const data = getProjectData('downloads',0,[])

  // eslint-disable-next-line no-unused-vars
  const [type, setType] = useState('all')
  // eslint-disable-next-line no-unused-vars
  const [filteredData, setFilteredData] = useState(data)

  const handleFilter = selected => {
    setType(selected)

    // TODO: handle selected filter.
    setFilteredData(data)
  }

  return (
    <Box
      sx={{
        pt: { lg: '4.625rem', xs: '2.5rem' },
        lineHeight: 1.4,
      }}
    >
    { clog(data) }
      <Box
        sx={{
          px: { lg: '2rem', xs: '1.25rem' },
          mb: { lg: '3.5rem', xs: '1.875rem' },
          maxWidth: '528px',
        }}
      >
        <Typography
          component='h2'
          variant='h2'
          sx={{
            fontWeight: 700,
            fontSize: { lg: '1.375rem', xs: '1.125rem' },
            mb: { lg: '1.875rem', xs: '1rem' },
          }}
        >
          Download materiale
        </Typography>
        <p>
          Din bolighandel skal være nem. Derfor har vi samlet relevante
          materialer, som du kan hente i PDF-format her.
        </p>
      </Box>

      {/* <Box sx={{ px: { lg: "2rem", xs: "1.25rem" }, mb: "0.5rem" }}>
        <Filter onSelect={handleFilter} />
      </Box> */}

      <Box>
        {data?.map((item, i) => (
          <DownloadItem key={i} {...item} />
        ))}
      </Box>
    </Box>
  )
}

export default Downloads
